var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0013 17.668C20.5779 17.668 17.668 20.5779 17.668 24.0013C17.668 27.4247 20.5779 30.3346 24.0013 30.3346C27.4247 30.3346 30.3346 27.4247 30.3346 24.0013C30.3346 20.5779 27.4247 17.668 24.0013 17.668Z",
    fill: "#7864F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1182 5H16.0545C9.83636 5 5 9.83636 5 15.8818V31.9455C5 38.1636 9.83636 43 16.0545 43H32.1182C38.1636 43 43 38.1636 43 31.9455V15.8818C43 9.83636 38.1636 5 32.1182 5ZM24 34.0182C18.4727 34.0182 14.1545 29.5273 14.1545 24.1727C14.1545 18.8182 18.4727 14.1545 24 14.1545C29.5273 14.1545 33.8455 18.6455 33.8455 24C33.8455 29.3545 29.5273 34.0182 24 34.0182ZM34.1909 16.2273C32.9818 16.2273 31.9455 15.1909 31.9455 13.9818C31.9455 12.7727 32.9818 11.7364 34.1909 11.7364C35.4 11.7364 36.4364 12.7727 36.4364 13.9818C36.4364 15.1909 35.4 16.2273 34.1909 16.2273Z",
    fill: "#7864F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon_3.4a4033b8a933e294d75a8c7382c93103.svg";
export { ForwardRef as ReactComponent };